import React from "react"
import { DialogContent } from "@mui/material"
import { StopExecutionError } from "@ui-seeker/core"

import AppDialog, { AppDialogCancel, AppDialogFooter, AppDialogHeader } from "./Dialog"
import { AppBulkEditAction } from "./BulkEditDialog"


// ModalSeeker with the app's dialog look: same props and the same open / close / Ok / Cancel behaviour, plus an
// icon and a subtitle for the header and an optional `footer` for dialogs that bring their own actions
export default function AppModal({
	isOpen, controller, title, subtitle, icon, headerActions, footer,
	hideActions = false, cancelText = "Cancel", successText = "Ok", disableCloseOnSuccess = false,
	containerProps = {}, titleProps = {}, contentProps = {}, cancelProps = {}, successProps = {},
	children,
}) {
	if (!isOpen) return null

	const handleCancel = e => {
		cancelProps?.onClick?.(e)
		controller()
	}

	const handleSuccess = e => {
		try {
			successProps?.onClick?.(e)
			!disableCloseOnSuccess && controller()
		} catch (error) {
			if (!(error instanceof StopExecutionError)) throw error
		}
	}

	const { p, maxWidth = 'md', ...dialogProps } = containerProps

	return <AppDialog open={isOpen} onClose={controller} maxWidth={maxWidth} scroll="paper" {...dialogProps}>
		{!!title && <AppDialogHeader icon={icon} title={title} subtitle={subtitle} actions={headerActions} onClose={controller} sx={titleProps?.sx}/>}
		<DialogContent {...contentProps} sx={{ px: 3, pt: title ? 1 : 3, pb: 2.5, ...contentProps?.sx }}>
			{children}
		</DialogContent>
		{(!!footer || !hideActions) && <AppDialogFooter>
			{footer || <>
				<AppDialogCancel {...cancelProps} onClick={handleCancel}>{cancelText}</AppDialogCancel>
				<AppBulkEditAction {...successProps} onClick={handleSuccess}>{successText}</AppBulkEditAction>
			</>}
		</AppDialogFooter>}
	</AppDialog>
}
